import React from "react";
import { ReactComponent as LightBulb } from "svgs/light-bulb.svg";
import CustomDropdown from "components/dropdown/custom";
import clsx from "clsx";

const getDisplayValue = (value) => {
	const [key, display] = value.split("=");
	return display || key;
};

const FeatureSelector = ({ dynamicFeature, activeFeature, onFeatureSelect, defaultValue }) => {
	if (!dynamicFeature.values.length) return null;

	const { key: dynamicFeatureKey, values: dynamicFeatureValues } = dynamicFeature;

	const Preview = () => (
		<div className="flex text-xs items-center gap-1 text-black uppercase w-full">
			<span className="w-5">
				<LightBulb className="size-4" />
			</span>
			<span className="text-center w-full">
				{activeFeature ? (
					<span className="font-bold">{getDisplayValue(activeFeature)}</span>
				) : (
					dynamicFeatureKey.split("=")[1] || dynamicFeatureKey.split("=")[0]
				)}
			</span>
		</div>
	);

	return (
		<div className={clsx(
			"absolute left-1 lg:left-4 top-2 lg:top-0 z-10 bg-lightBeige w-fit min-w-28 max-w-34 md:max-w-34 border border-beige",
			activeFeature === "OFF" && "!bg-iceMist border-iceMist")}>
			<CustomDropdown
				Preview={() => <Preview />}
				onSelect={onFeatureSelect}
				values={dynamicFeatureValues}
				buttonClassName="!py-0.5 lg:!py-1 !px-1 lg:!px-2"
			>
				{dynamicFeatureValues.map((feature) => {
					const isActive =
						feature === activeFeature || (!activeFeature && feature === defaultValue);
					return (
						<button
							key={feature}
							value={feature}
							className={clsx(
								"p-2 hover:bg-lightBeige hover:text-black text-dimGray w-full text-sm text-center",
								isActive && "bg-seashell hover:bg-seashell hover:text-darkGray"
							)}
						>
							<span className="text-xs">{getDisplayValue(feature)}</span>
						</button>
					);
				})}
			</CustomDropdown>
		</div>
	);
};

export default FeatureSelector;